import { useStaticQuery, graphql } from 'gatsby';

interface UseSexNamesResponse {
  id: string;
  name: string;
}
export function useSexName(): UseSexNamesResponse[] {
  const { allPawsSexName } = useStaticQuery(graphql`
    query {
      allPawsSexName {
        nodes {
          id: remoteId
          name
        }
      }
    }
  `);

  return allPawsSexName.nodes;
}
